
import React from "react";

class Formatter {
    static DisplayValue = (value: any): React.ReactElement => {

        var [numFmt, num] = Formatter.FormatNumber(value);

        return React.createElement('span', { className: num < 0 ? "negative-num" : "positive-num" }, numFmt);
    };

    static DisplayPercent = (value: any, useSymbol: boolean = true): React.ReactElement => {

        var [numFmt, num] = Formatter.FormatPercent(value, useSymbol);

        return React.createElement('span', { className: num < 0 ? "negative-num" : "positive-num" }, numFmt);
    }

    static FormatNumber = (value: any): [string, number] => {

        if (Number.isNaN(value) || value === undefined)
            return ["-", 0];

        const num = value as number;
        let numFmt = new Intl.NumberFormat('pt-BR', { minimumIntegerDigits: 1 }).format(num);

        return [numFmt, num];
    };

    static FormatPercent = (value: any, useSymbol: boolean = true): [string, number] => {

        if (Number.isNaN(value) || value === undefined || !Number.isFinite(value))
            return ["-", 0];

        const num = value as number;
        let numFmt = new Intl.NumberFormat('pt-BR', { minimumIntegerDigits: 1, maximumFractionDigits: 0 }).format(Math.round(num * 100) / 100) + (useSymbol ? "%" : "");

        return [numFmt, num];
    }
}

export default Formatter;